import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraActionList } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraInlineBanner, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
import { useVehicleMismatchSignals } from './hooks';
export function LcatsOnVehicle({ dossier: d }) {
    const signals = useVehicleMismatchSignals(d.vehicleId, true).data?.signals ?? [];
    const reviewHref = `/registries/review-queue?group=labor-categories&vehicle=${encodeURIComponent(d.vehicleId)}`;
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Labor categories on this vehicle",
                action: `${d.entriesAsWritten} as written across holders · ${d.entriesMapped} mapped to anchors`
            }),
            d.anchors.length === 0 && /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: d.entriesMapped > 0 ? 'No mapped solicitation categories on this vehicle yet.' : 'No labor categories mapped on this vehicle yet.'
            }),
            /*#__PURE__*/ _jsx(SpecraActionList, {
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryVehicle.lcatRow,
                trailing: null,
                items: d.anchors.map((row, i)=>({
                        id: row.anchor?.id ?? String(i),
                        label: row.anchor?.name ?? 'Labor category',
                        href: row.anchor ? registryHref(row.anchor) ?? undefined : undefined,
                        meta: `asked for in ${row.solicitationCount} solicitations · ${row.holdersPriced} holders priced it`
                    }))
            }),
            signals.map((s)=>/*#__PURE__*/ _jsx(SpecraInlineBanner, {
                    tone: "warning",
                    "data-testid": Testids.registryVehicle.mismatchSignal,
                    action: // questionId → sectionId needs the RFI's question list (one fetch per banner);
                    // the labor-categories page is where the mismatch is actionable, so link there.
                    /*#__PURE__*/ _jsx(SpecraLink, {
                        "data-testid": Testids.registryVehicle.mismatchSignalReview,
                        renderLink: renderRouterLink,
                        href: `/rfi-response/${encodeURIComponent(s.routeId)}/labor-categories`,
                        children: "Review →"
                    }),
                    children: `Vehicle mismatch · ${s.rfiLabel} asks for ${s.categoryCount} ${s.categoryCount === 1 ? 'category' : 'categories'} that only ${s.categoryCount === 1 ? 'exists' : 'exist'} on ${s.otherVehicles.map((v)=>v.name).join(', ')}`
                }, s.signalId)),
            !!d.mismatch?.count && /*#__PURE__*/ _jsx(SpecraActionList, {
                items: [
                    {
                        id: 'mismatch',
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "warning",
                            children: "Vehicle mismatch"
                        }),
                        label: d.mismatch.sampleText,
                        actions: /*#__PURE__*/ _jsx(SpecraLink, {
                            "data-testid": Testids.registryVehicle.mismatchReview,
                            renderLink: renderRouterLink,
                            href: reviewHref,
                            children: "Review →"
                        })
                    }
                ]
            })
        ]
    });
}
